import React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import PropTypes from 'prop-types';
import GradeIcon from '../../../components/assignments/AssignmentsCard/GradeIcon';
import { connect } from 'react-redux';
import { PARAMS, ROLE } from '../../../const';
import { API_USER_PICTURE } from '../../../services/api/apiConst';

const PASSED_GRADE = 40;

class CommentBox extends React.Component {
  getColorFromGrade() {
    const { grade } = this.props;
    if (grade > PASSED_GRADE) {
      return 'green';
    }
    return 'red';
  }

  getDefaultCommentFromGrade() {
    const { grade } = this.props;

    if (grade > PASSED_GRADE) {
      return I18n.t('panels.assignment.taskPass');
    }
    return I18n.t('panels.assignment.taskFail');
  }

  render() {
    const { userId, title, grade, showCommentBox, toggleEditMode, isTeacher, role, comment, isFirstTry } = this.props;

    const defaultTitle = isTeacher ? 'panels.assignment.evaluated' : 'panels.assignment.globalAssessment';
    const avatarPicture = userId
      ? userId.substring(0, 4) === 'http'
        ? userId
        : API_USER_PICTURE.replace(PARAMS.USER, userId)
      : undefined;
    const titleLabel = title ? title : I18n.t(defaultTitle);

    return showCommentBox ? (
      <div className="global-task-review-container">
        <div>
          <div className="section-title-label no-margin">
            {titleLabel}
            {isFirstTry && (
              <span style={{ marginLeft: '30%' }} className="max-characters-blur">
                {I18n.t('panels.assignment.firstEvaluation')}
              </span>
            )}
          </div>
          <div className={`comment-box-container ${this.getColorFromGrade()}`}>
            <div className="comment-container">
              {userId ? (
                <div className="avatar-container">
                  <img src={avatarPicture} />
                </div>
              ) : (
                undefined
              )}
              <div>
                <div className="comment-label">
                  {comment ? comment : <div className="no-comments">{this.getDefaultCommentFromGrade()}</div>}
                </div>
                {isTeacher && role !== ROLE.COINSTRUCTOR && !isFirstTry && (
                  <span className="edit-link" onClick={toggleEditMode}>
                    {` [${I18n.t('common.option.edit')}]`}
                  </span>
                )}
              </div>
            </div>
            <div className="emoji-container">
              <GradeIcon active grade={grade} />
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div />
    );
  }
}

CommentBox.propTypes = {
  comment: PropTypes.string,
  userId: PropTypes.string,
  title: PropTypes.string,
  grade: PropTypes.number,
  toggleEditMode: PropTypes.func,
  showCommentBox: PropTypes.bool,
  isTeacher: PropTypes.bool,
  role: PropTypes.string
};

function mapStateToProps(state) {
  return {
    role: state.classrooms.selectedClassroom.classroom.role
  };
}

export default connect(mapStateToProps)(CommentBox);
